import React, { useState } from 'react';
import { Button } from '@mui/material';
import AdTable from '../components/AdTable';
import PropTypes from 'prop-types';
import { withScoutTheme } from '../../ThemeContext/ThemeContext';
import axios from 'axios';

import useStyles from './useStyles';

const ADTYPES = [
  {
    id: ['open', 'new'],
    name: 'Active'
  },
  {
    id: ['expired'],
    name: 'Expired'
  },
  {
    id: ['archived'],
    name: 'Archived'
  }
];

function AdList({ job_ads, requestNewAdUrl }) {
  const [ads, setAds] = useState(job_ads);
  const [selectedAdType, setSelectedAdType] = useState(ADTYPES[0].id);

  const classes = useStyles();

  async function getNewAdUrl() {
    try {
      const token = document.querySelector('meta[name="csrf-token"]').content;
      const { data } = await axios.post(requestNewAdUrl, {
        authenticity_token: token,
        headers: {
          'Content-Type': 'x-www-form-urlencoded'
        }
      });
      window.location = data.url;
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <div className={classes.containerOuter}>
      <div className={classes.container}>
        <div className={classes.banner}>
          <div id="indeed-logo"></div>
          <Button
            style={{ minWidth: 110, fontSize: 12 }}
            disableElevation
            className={classes.buttonSecondary}
            onClick={() => getNewAdUrl()}
          >
            New Ad
          </Button>
        </div>
        <div className={classes.toggleButtonGroup}>
          {ADTYPES.map((type) => (
            <Button
              key={type.name}
              disableElevation
              onClick={() => setSelectedAdType(type.id)}
              className={
                type.id[0] === selectedAdType[0]
                  ? [classes.buttonPrimary, classes.buttonActive]
                  : classes.buttonGrey
              }
            >
              {type.name}
            </Button>
          ))}
        </div>
        <AdTable
          jobAds={job_ads}
          ads={ads.filter((ad) => selectedAdType.includes(ad.status))}
          setAds={setAds}
        />
      </div>
    </div>
  );
}

AdList.propTypes = {
  job_ads: PropTypes.array.isRequired,
  requestNewAdUrl: PropTypes.string.isRequired
};

export default withScoutTheme(AdList);
